//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  data () {
    return {

      dataForm: {
        ModelSort: '',
        SeriesNOSort: ''
      },
      dataFormRules: {
        ModelSort: [
          { required: true, message: '请输入型号顺序', trigger: 'blur' }
        ],
        SeriesNOSort: [
          { required: true, message: '请输入系列号顺序', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {

    editSubmit: function () {
      this.$refs.dataForm.validate((valid) => {
        if (valid) {
          this.$api.saveBarcodeSort(this.dataForm).then(res => {
            if (res.Status === 1) {
              this.$message({ message: '保存成功', type: 'success' })
              this.editDialogVisible = false
            } else {
              this.$alert(res.Message, '错误', {
                confirmButtonText: '确定'
              })
            }
          })
        }
      })
    }
  },
  mounted () {
    this.$api.getBarcodeSort().then(res => {
      if (res.Status === 1) {
        this.dataForm.ModelSort = res.Entity.ModelSort
        this.dataForm.SeriesNOSort = res.Entity.SeriesNOSort
      } else {
        this.$alert(res.Message, '错误', {
          confirmButtonText: '确定'
        })
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/admin/BarcodeSort.vue